import getXTicksByType from "./getXTicksByType";

function getChartDataInRange({
  earningsData,
  range,
}: {
  range: { min: number; max: number };
  earningsData: RangeEarningsEntry[];
}) {
  if (!range) {
    return earningsData;
  }

  return earningsData.filter((el) => {
    const startTime = new Date(el.start_date).getTime();
    const endTime = new Date(el.end_date).getTime();

    if (startTime >= range.min && endTime <= range.max) {
      return true;
    }

    return false;
  }, []);
}

export default function getChartData({
  earningsData,
  range,
  xTicks,
}: {
  range: { min: number; max: number };
  earningsData: RangeEarningsEntry[];
  xTicks: ReturnType<typeof getXTicksByType>;
}) {
  const chartDataInRange: (RangeEarningsEntry & {
    x: number;
    earningsToDisplay: number;
  })[] = getChartDataInRange({
    range,
    earningsData,
  }).map((el) => ({
    ...el,
    x: new Date(el.start_date).getTime(),
    earningsToDisplay:
      el.earnings.transfer_to_orchid_pro + el.earnings.invoice_paid_by_patient,
  }));
  const now = Date.now();
  return xTicks.reduce((prev, x) => {
    const id = chartDataInRange.findIndex((item) => item.x === x);
    // not found
    if (id < 0) {
      if (x > now) {
        // if future
        prev.push({
          start_date: "",
          end_date: "",
          x,
          earnings: {
            count: 0,
            paid_by_patient: 0,
            transfer_to_orchid_pro: 0,
            site_fees: 0,
            orchid_discount: 0,
            invoice_paid_by_patient: 0,
          },
          earningsToDisplay: 0,
        });
      }
    } else {
      prev.push(chartDataInRange[id]);
    }
    return prev;
  }, [] as typeof chartDataInRange);
}
